__turbopack_context__.v({
  "action": "SideCardAction-module-scss-module__EEVRFG__action",
});
